<template>
	<div>
		<compWrapper :title="$t('global.common.base_information',{defaultValue:'基本信息'})" theme="primary">
			<compFormEdit
				ref="formbase"
				align="center"
				class="margin-top-15"
				:formdata="getBase"
				v-model="packageBase"
			></compFormEdit>
		</compWrapper>
		<compWrapper :title="$t('fbb.settlement.alladress',{defaultValue:'收/发货地址信息'})" theme="info">
			<compFormEdit
				ref="address"
				align="center"
				class="margin-top-15"
				:formdata="getAddress"
				v-model="packageAddress"
			></compFormEdit>
		</compWrapper>
		<compWrapper :title="$t('fbb.fedex.package_size',{defaultValue:'包裹尺寸'})" theme="warning">
			<vAlert class="margin-15" theme="error">{{$t('fbb.fedex.packagesize_tip',{defaultValue:'包裹长、宽、高请输入正整数，若输入小数，则自动向上取整；包裹重量保留小数点后两位，超过两位则四舍五入保留两位'})}}</vAlert>
			<compFormEdit
				ref="package"
				align="center"
				class="margin-top-15"
				:formdata="getPackage"
				v-model="packageSize"
			></compFormEdit>
			<footer class="width-50per" style="padding-left:120px;margin-left:25%;">
				<vButton theme="primary" class="margin-right-15" @click="calculate">{{$t('fbb.fedex.calc_measure',{defaultValue:'开始测算'})}}</vButton>
				<vButton theme="error" class="margin-right-15" @click="reset">{{$t('global.common.btn_reset',{defaultValue:'重置'})}}</vButton>
			</footer>
		</compWrapper>
		<compWrapper :title="$t('fbb.fedex.calc_results',{defaultValue:'测算结果'})" theme="info">
			<div class="margin-left-15 margin-top-15">
				<span>{{$t('fbb.settlement.zoneCode',{defaultValue:'分区代码'})}}：{{jsonData.zoneCode}}</span>
				<!-- <span class="margin-left-30">体积重：{{json.volumeWeight}}</span> -->
				<span class="margin-left-30">{{$t('global.common.perimeter',{defaultValue:'周长'})}}：{{jsonData.girth}}</span>
			</div>
			<compCalc :data="costList" :coltype="'costcacl'"></compCalc>
		</compWrapper>
        <vModal v-model="showorder" :title="$t('fbb.fedex.chose_ordernum',{defaultValue:'请选择销售出库订单号'})" width="900" :showFooter="false">
			<compTableList v-bind="handleOrderList"/>
		</vModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { HttpCostCalc,HttpCostOrderList,HttpFindByOrgIdAndOrgWarehouseId,HttpSYSAddress,HttpResiveAddress } from "@/service/fedex";

import compCalc from "./calc";
import mixin from './mixin'
export default {
	mixins: [mixin],
	components: {
		compCalc,
		compWrapper: () => import("@components/templates/wrapper"),
        compFormEdit: () => import("@components/templates/formedit"),
        compTableList: () => import("@components/templates/tablelist"),
        
	},
	data() {
		return {
			loading: false,
			packageBase: {
				orgId: this.$store.state.organization.id,
				carrierCode: "",
			},
			packageAddress: {
				shipCountry: "US",
				receiveCountry: "US",
			},
			packageSize: {
				sizeUnit: "inch",
				weightUnit: "lbs",
            },
            showorder:false,
			costList: [],
			jsonData:{},
		};
	},
	computed: {
		...mapGetters('dictionary',['getBillcusWareList']),
		...mapGetters('dictionary', ['getCarrierAllList']),
		getOrderStatus(){
			return {
				'0':this.$t('fbb.alloment.draft', { defaultValue: "草稿" }),
				'5':this.$t('fbb.alloment.wait_for_outbound', { defaultValue: "待出库" }),
				'10':this.$t('fbb.alloment.outbounding', { defaultValue: "出库中" }),
				'70':this.$t('global.common.finished', { defaultValue: "已完成" }),
				'90':this.$t('global.common.closed', { defaultValue: "已关闭" }),
			}
		},
        handleOrderList() {
			return {
				columns: this.orderColumns,
				Searchs: {
					show: true,
					style: "border:none;",
					labelWidth: "auto",
					align: "left"
                },
                startUp: true,
                initFormData: {
					search:{
						'IN_orderStatus':['assigned','picked','shipped'],
					}
				},
				SearchsData: [
					{
						label:this.$t('fbb.fedex.order_num',{defaultValue:'销售出库订单号'}),
						tag: "vInput",
						key: "EQ_orderNo",
						show: true
					},
				],
				ajaxRequest: HttpCostOrderList,
			};
        },
        orderColumns(){
            return [
				{
					title: this.$t('fbb.adjustment.list_sale',{defaultValue:'销售订单'}),
					key: "saleOrderNo",
				},
				{
					title: this.$t('erp.b2c.product_orgwarehouse',{defaultValue:'仓库'}),
					key: "orgWarehouseCode",
				},
				{
					title: this.$t('erp.b2c.search_orderstatus',{defaultValue:'订单状态'}),
					key: "saleOrderStatus",
					render:(h,{row})=>{
						return this.getOrderStatus[row.saleOrderStatus]||"";
					}
				},
				{
					title: this.$t('global.common.operation',{defaultValue:'操作'}),
					width: 120,
					align: "center",
					render: (h, { row }) => {
						return <vButton theme="primary" nativeOnClick={this.getOrderInfo.bind(this, row)}>{this.$t('fbb.inbound.choose',{defaultValue:'选择'})}</vButton>
					}
				}
			]
        },
		getBase() {
			const carrierCode = this.packageBase.carrierCode;
			return [
				{
					label: this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),
					key: "orderId",
					required: false,
					children: (h) => {
						return <vIcon
							type="search"
							center
							slot="suffix"
							style="padding:6px;pointer-events: initial;"
							size="18"
							nativeOnClick={this.handleModalplat.bind(this)}
						/>
					},
					props: {
						readonly: true
					}
				},
                {
					label: this.$t('fbb.fedexcost.account',{defaultValue:'账户'}),
					tag: "vInput",
					key: "account",
					// options: this.getOrgOpt,
					// props: {
					// 	filterable: true
					// },
					required:false,
				},
				{
					label: this.$t('fbb.alloment.carrier_code',{defaultValue:'承运商'}),
					tag: "vSelect",
					key: "carrierCode",
					options: this.getCarrierAllList,
					props: {
						filterable: true
					},
					required: false,
				},
				{
					label: this.$t('fbb.alloment.carrier_server',{defaultValue:'承运商服务'}),
					tag: "vSelect",
					key: "carrierServiceCode",
					options: this.getCarrierServiceOpt.filter(item => (!carrierCode || item.attach.carrierCode == carrierCode)),
					props: {
						filterable: true
					},
					required: false,
				},
			];
		},
		getAddress() {
			return [
				{
					label: this.$t('fbb.settlement.shipCountry',{defaultValue:'发货地国家'}),
					tag: "vSelect",
					key: "shipCountry",
					options: this.getCountryList
                },
                {
                    label: this.$t('global.common.deliveryWarehouse',{defaultValue:'发货仓库'}),
                    tag: 'vSelect',
                    key: 'shipOrgWarehouseCode',
                    options:this.getBillcusWareList.map(item=>{
						return {
							value:item.attach.code,
							label:item.attach.code,
						}
					}),
                    required:false,
                    props:{
                        filterable:true,
                    }
                },
				{
					label: this.$t('fbb.settlement.shipPostal',{defaultValue:'发货地邮编'}),
                    key: "shipPostal",
                    required:false,
				},
				{
					label: this.$t('fbb.settlement.receiveCountry',{defaultValue:'收货地国家'}),
					tag: "vSelect",
					key: "receiveCountry",
					options: this.getCountryList
				},
				{
					label: this.$t('fbb.settlement.receiveState',{defaultValue:'收货地州/省'}),
					key: "receiveState",
					required: false,
				},
				{
					label: this.$t('fbb.settlement.receiveCity',{defaultValue:'收货地城市'}),
					key: "receiveCity",
					required: false,
				},
				{
					label: this.$t('fbb.settlement.receivePostal',{defaultValue:'收货地邮编'}),
					key: "receivePostal",
					formItem: {
						rules: {
							required: true,
							// message: "该信息不能为空,请填写",
							validator(rule, value, callback) {
								// console.log(!(/^[0-9-0-9]{5,}$/g.test(value)))
								if (!value || !/^[0-9-0-9]{5,}$/g.test(value)) {
									callback(this.$t('fbb.fedex.receivecode_tip',{defaultValue:'该信息不能为空,且长度不能少于五位'}));
								} else {
									callback();
								}
							},
						},
					}
				},
				{
					label: this.$t('erp.b2c.shipping_address',{defaultValue:'收货地'}),
					tag: "vTextarea",
					key: "receiveAddress",
					required: false,
				},
				{
					label: this.$t('fbb.fedex.address_attr',{defaultValue:'地址属性'}),
					tag: "vCheckBox",
					key: "isResidential",
					required: false,
					props: {
						trueValue: 1,
						falseValue: 0,
					},
					children(h) {
						return <div>{this.$t('fbb.fedex.address_per',{defaultValue:'住宅地址'})}<span class="color-error padding-left-20">{this.$t('fbb.fedex.address_pertip',{defaultValue:'若勾选，则默认为住宅地址进行运费测算'})}</span></div>
					},
				},
			]
		},
		getPackage() {
			return [
				{
					label: this.$t('fbb.fedex.sizeUnit',{defaultValue:'尺寸单位'}),
					tag: "vSelect",
					key: "sizeUnit",
					options: [{
						label: "inch（英寸）",
						value: "inch"
					}, {
						label: "cm（厘米）",
						value: "cm"
					}]
				}, {
					label: this.$t('fbb.fedex.sizeBase',{defaultValue:'尺寸信息'}),
					tag: "vInputNumber",
					key: "length",
					span: "6",
					offset: 6,
					props: {
						placeholder: this.$t('global.common.length',{defaultValue:'长'}),
						precision: 0,
						math: "ceil",
						min: 1
					},
				}, {
					// label: "尺寸信息",
					tag: "vInputNumber",
					key: "width",
					span: "4",
					offset: 0,
					props: {
						placeholder: this.$t('global.common.width',{defaultValue:'宽'}),
						precision: 0,
						math: "ceil",
						min: 1
					},
					formItem: {
						labelWidth: 30,
					}
				}, {
					// label: "尺寸信息",
					tag: "vInputNumber",
					key: "height",
					span: "4",
					offset: 0,
					props: {
						placeholder: this.$t('global.common.height',{defaultValue:'高'}),
						precision: 0,
						math: "ceil",
						min: 1
					},
					formItem: {
						labelWidth: 30,
					}
				}, {
					label: this.$t('fbb.headlogistics.weight_unit',{defaultValue:'重量单位'}),
					tag: "vSelect",
					key: "weightUnit",
					options: [{
						label: "lbs（磅）",
						value: "lbs"
					}, {
						label: "oz（盎司）",
						value: "oz"
					}, {
						label: "g（克）",
						value: "g"
					}]
				}, {
					label: this.$t('fbb.expresspackage.package_weight',{defaultValue:'包裹重量'}),
					tag: "vInputNumber",
					key: "weight",
					props: {
						precision: 2,
						min: 0
					}
				},
			]
		},
	},
	methods: {
        handleModalplat(){
            this.showorder = true
		},
		getOrderInfo(data) {
			// console.log(data)
			let warejson = this.getBillcusWareList.filter(item=>{ return item.attach.code == data.orgWarehouseCode})[0] || {}
			// console.log(warejson)
			// 请求发货邮编
			this.showorder=false;
			this.$set(this.packageBase,'orderId',data.saleOrderNo)
			this.$set(this.packageAddress,'shipOrgWarehouseCode',warejson.attach.code)
			// this.getPostal(warejson.value)
			this.getResiveAddress(data.id)

			
			// this.packageBase.orderId = data.saleOrderNo;
		},
		getResiveAddress(tid){
			HttpResiveAddress({
				id:tid
			}).then(res=>{
				this.$set(this.packageAddress,'shipPostal',res.data.shipPostal)
				this.$set(this.packageAddress,'receiveState',res.data.receiveState)
				this.$set(this.packageAddress,'receiveCity',res.data.receiveCity)
				this.$set(this.packageAddress,'receivePostal',res.data.receivePostal)
				this.$set(this.packageAddress,'receiveAddress',res.data.receiveAddress)
			},err=>{

			})
		},
		reset() {
			this.packageBase = {};
			this.packageAddress = {};
			this.packageSize = {};
			this.costList = [];
			this.$refs.formbase.resetValidate();
			this.$refs.address.resetValidate();
			this.$refs.package.resetValidate();
		},
		async calculate() {
			const valid = await Promise.all([this.$refs.formbase.validate(), this.$refs.address.validate(), this.$refs.package.validate()]);
            if (!valid) return;
            if(!this.packageAddress.shipOrgWarehouseCode && !this.packageAddress.shipPostal) {
                this.$VMessage.error(this.$t('fbb.fedex.packware_postal',{defaultValue:'发货仓库和发货邮编必填其一'}))
                return
            }
			this.loading = true;
			HttpCostCalc({
				costCalculationPackageBaseInfoItem: this.packageBase,
				costCalculationPackageAddressItem: this.packageAddress,
				costCalculationPackageItem: this.packageSize,
			}).then(
				res => {
					this.jsonData = res.data[0]

					res.data.map(item=>{
						this.costList.push(item.calculationCarrierItem)
					})
					// 根据账户进行排序
					// console.log(this.costList)
					this.costList = this.costList.sort(function(a,b){
						return a.account.localeCompare(b.account)
					})
					this.loading = false;
				},
				err => {
					this.loading = false;
					this.$VMessage.error(err.message);
				}
			);
		}
	}
};
</script>
